/**
 * Miniature SVG preview of a label template — used in dropdown pickers
 * and thumbnail strips so users can identify a template at a glance
 * without opening it.  Purely client-side: draws each field as a coloured
 * box scaled to the label's mm dimensions.
 */
export default function LabelThumbnail({ tpl, width = 96, height = 60, active = false }) {
  if (!tpl || !tpl.width_mm || !tpl.height_mm) {
    return (
      <div style={{ width, height }}
           className="rounded-md bg-[var(--pop-cream)]/40 border border-dashed border-[var(--border)]" />
    );
  }
  const pad = 2;
  const boxW = width - 2 * pad;
  const boxH = height - 2 * pad;
  // Fit the label aspect ratio inside our box.
  const ratio = Math.min(boxW / tpl.width_mm, boxH / tpl.height_mm);
  const w = tpl.width_mm * ratio;
  const h = tpl.height_mm * ratio;
  const offsetX = (width - w) / 2;
  const offsetY = (height - h) / 2;

  const colorFor = (t) => {
    if (t === "logo") return "#111827";
    if (t === "barcode" || t === "qr") return "#4b5563";
    if (t === "text") return "#d1d5db";
    return "#EB75B5"; // pink accent for data fields
  };

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}
         className={`rounded-md ${active ? "ring-2 ring-[var(--pop-pink)]" : "ring-1 ring-[var(--border)]"} bg-white`}>
      <rect x={offsetX} y={offsetY} width={w} height={h}
            fill={tpl.background_color || "#ffffff"} />
      {(tpl.fields || []).map((f, i) => (
        <rect key={i}
              x={offsetX + f.x * ratio}
              y={offsetY + f.y * ratio}
              width={Math.max(1, f.width * ratio)}
              height={Math.max(1, f.height * ratio)}
              fill={colorFor(f.type)}
              opacity={f.type === "text" ? 0.55 : 0.85}
              rx={0.5} />
      ))}
    </svg>
  );
}
